(()=>{if(customElements.get('as-crystal-carat-preview'))return;
let rememberedView='original';
class CrystalPreview extends HTMLElement{
 connectedCallback(){
  if(this.dataset.ready)return;
  this.range=this.querySelector('[data-carat-range]');this.bandRange=this.querySelector('[data-band-range]');this.widths=[1.5,2,2.5,3,4];this.stage=this.querySelector('.as-carat-stage');
  this.tabs=this.querySelector('.as-carat-tabs');
  this.view=rememberedView;this.controller=new AbortController();const signal=this.controller.signal;
  this.tabs.querySelectorAll('[data-view]').forEach(b=>b.addEventListener('click',()=>{this.view=b.dataset.view;rememberedView=this.view;this.render();},{signal}));
  this.range.addEventListener('input',()=>this.openPreview(),{signal});
  this.range.addEventListener('change',()=>this.applyCarat(),{signal});
 this.bandRange.addEventListener('input',()=>this.openPreview(),{signal});
 this.bandRange.addEventListener('change',()=>this.applyCarat(),{signal});
  document.addEventListener('change',e=>{if(!this.contains(e.target)&&e.target.closest('variant-picker'))setTimeout(()=>this.sync(),50);},{signal});
  document.addEventListener('variant:update',()=>this.sync(),{signal});
 this.closest('.shopify-section')?.addEventListener('shopify:product:select',event=>{
  Promise.resolve(event.promise).then(({detail})=>requestAnimationFrame(()=>{
   if(!this.isConnected)return;
   this.sync();
   const incoming=detail?.html?.querySelector('.product-details product-price [ref="priceContainer"]');
   const current=this.closest('product-component')?.querySelector('.product-details product-price [ref="priceContainer"]');
   if(incoming&&current)current.replaceChildren(...[...incoming.childNodes].map(node=>node.cloneNode(true)));
  })).catch(()=>undefined);
 },{signal});
  this.dataset.ready='true';this.sync();
  this.moveTabs();
  this.tabsObserver=new MutationObserver(()=>this.moveTabs());
  const product=this.closest('product-component');
  if(product)this.tabsObserver.observe(product,{childList:true,subtree:true});
 }
 disconnectedCallback(){this.controller?.abort();this.tabsObserver?.disconnect();this.tabs?.remove()}
 moveTabs(){
  const heading=this.closest('product-component')?.querySelector('.product-details h1');
  if(!heading||!this.tabs)return;
  const target=heading.closest('.text-block')||heading;
  if(target.previousElementSibling!==this.tabs)target.before(this.tabs);
 }
 picker(){return this.closest('product-component')?.querySelector('variant-picker')||document.querySelector('.product-details variant-picker')}
 stoneSelect(){return [...(this.picker()?.querySelectorAll('select')||[])].find(s=>[...s.options].some(o=>/\d+(?:\.\d+)?\s*CT.*Radiant/i.test(o.textContent)))}
 carat(t){return Number(t?.match(/(\d+(?:\.\d+)?)\s*CT/i)?.[1])}
 sync(){const s=this.stoneSelect();const v=s?.selectedOptions[0];const n=this.carat(v?.textContent);
 if(n>=2&&n<=10)this.range.value=String(n);
 const width=this.bandWidth(v?.value);this.bandRange.value=String(Math.max(0,this.widths.indexOf(width)));
 if(s)for(const option of s.options){const hide=this.bandWidth(option.value)!==width;if(option.hidden!==hide)option.hidden=hide;const label=option.value.split(' | Band ')[0];if(option.textContent!==label)option.textContent=label;}
 this.render()}
 bandWidth(t){return Number(t?.match(/\| Band ([\d.]+) mm/)?.[1]||1.5)}
 render(){
  const n=Number(this.range.value),i=Number(this.bandRange.value),width=this.widths[i];this.dataset.view=this.view;
  this.querySelector('[data-carat-output]').textContent=n+' ct';this.range.setAttribute('aria-valuetext',n+' carats');
  this.querySelector('[data-band-output]').textContent=width.toFixed(2)+' mm';
 this.querySelector('[data-band-price]').textContent=i?'Adds $'+(i*200).toFixed(2):'Included in base price';
 this.bandRange.setAttribute('aria-valuetext',width.toFixed(2)+' millimeters, '+(i?'adds '+i*200+' dollars':'included'));
 this.querySelectorAll('[data-band-image]').forEach(img=>{const selected=Number(img.dataset.bandImage)===width;if(selected&&this.view!=='original'&&!img.hasAttribute('src')){const source=img.dataset.previewSrc;img.sizes='(min-width: 750px) 400px, 100vw';img.srcset=[480,750,1122].map(w=>source.replace(/width=1122/,'width='+w)+' '+w+'w').join(', ');img.src=source;}img.hidden=!selected;});
 this.tabs.querySelectorAll('[data-view]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.view===this.view)));
  if(this.view!=='original'){
   const stone=this.stage.querySelector('[data-stone-src]');if(stone&&!stone.hasAttribute('href'))stone.setAttribute('href',stone.dataset.stoneSrc);
   const scale=Math.cbrt(n/3);
   this.stage.style.setProperty('--stone-width',(11.8*scale)+'%');
   this.stage.setAttribute('aria-label',n+' carat radiant diamond with '+width.toFixed(2)+' millimeter band; approximate on-hand preview');
  }
 }
 openPreview(){this.view='hand';rememberedView='hand';this.render()}
 applyCarat(){
  const s=this.stoneSelect(),n=Number(this.range.value),status=this.querySelector('.as-carat-status');
  if(!s){status.textContent='Preview only. Choose your center size in the product options.';return}
  const width=this.widths[Number(this.bandRange.value)];
 const current=s.selectedOptions[0]?.value||'',grade=/E\s*VVS2/i.test(current)?'E VVS2':'F VS1';
  const option=[...s.options].find(o=>this.carat(o.value)===n&&o.value.includes(grade)&&this.bandWidth(o.value)===width&&!o.disabled);
  if(!option){status.textContent='Preview only. This selection is unavailable in the current options.';return}
  status.textContent='';s.value=option.value;s.dispatchEvent(new Event('change',{bubbles:true}));
 }
}
customElements.define('as-crystal-carat-preview',CrystalPreview);
})();
